import { useEffect } from "react";
import axios from "axios";
import { store } from "../redux/storeOf";
import { BOM } from "../services/definedMethod";
import cnt from "../services/definedConstant";

/**
 * React hook to setup axios interceptors for 401 unauthorized errors
 * Only logs when both conditions are met:
 * 1. Response status is 401 Unauthorized
 * 2. User authentication token is present
 */
export const useAxiosSessionInterceptor = () => {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const is401Error = error.response && error.response.status === 401;
        const state = store.getState();
        const userToken = state?.AuthenticationData?.userToken;
        if (is401Error && userToken) {
          BOM.AlertMsg(cnt.SUCCESS, "Session expired, please login again");
          console.error("401 Unauthorized Error Detected (with auth token)");
          window.location.href = "/sign-in";
          return Promise.reject(error);
        } else {
          return Promise.reject(error);
        }
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);
};
